import PageWrapper from "../components/layout/PageWrapper";
import ServiceMaster from "../components/serviceMaster/ServiceMaster";

const ServiceMasterPage = () => {
  return (
    <PageWrapper>
      <ServiceMaster />
    </PageWrapper>
  );
};

export default ServiceMasterPage;
